export default "__VITE_ASSET__vKy1w6PY__"